<template lang="pug">
  #default-layout
    #nav-header
      .container
        .row.nav-bar.align-items-center
          b-navbar.align-items-stretch.px-md-0.w-100(toggleable='md' type='')
            b-navbar-brand.p-0.my-2
              router-link.logo-amulen-negativo(to="/")
            .d-flex.flex-wrap.col-12.col-md-auto.ml-auto.mt-2.mt-md-0.p-0
              .d-flex.col-12.px-0.align-items-center.justify-content-md-end.data-user
                font-awesome-icon.me-2.h5.my-0(icon="user-circle")
                span.me-2
                  | {{ userName }}
                span |
                span.ms-2
                  | {{ userType }}
                b-navbar-toggle.ms-auto(target='nav-collapse')
              .d-flex.col-12.px-0.justify-content-end
                b-collapse#nav-collapse.align-items-end(is-nav)
                  b-navbar-nav.ms-auto
                    router-link(tag="b-nav-item" to="/")
                      span Inicio
                    b-nav-item-dropdown(text='Mi cuenta' right)
                      router-link(tag="b-dropdown-item" to="/change-pass")
                        font-awesome-icon.text-white.me-2(icon="lock")
                        | Cambiar contraseña
                      b-dropdown-item(@click.prevent="logOut")
                        font-awesome-icon.text-white.me-2(icon="power-off")
                        | Cerrar sesión
    .container.px-0
      breadcrumbs
      slot
    footer#footer
      .row
        .col
          p.text-muted.m-0 &copy; ESCALENO 2020
</template>

<script>
export default {

  name: 'DefaultLayout',

  data () {
    return {
      userName: localStorage.getItem('name').concat(' ').concat(localStorage.getItem('lastname')),
      userType: localStorage.getItem('clientName')
    }
  },
  methods: {
    async logOut () {
      await this.$store.dispatch('destroySession')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="stylus">

</style>
